import { types, Instance, getSnapshot } from "mobx-state-tree";
// models
import CartModel from "src/models/cart-model";
// helpers
import { formatPrice } from "src/base/helpers/price";
import StoreHelper from "src/base/helpers/store-helper";

const OrderItemModel = types
  .model({
    id: types.maybeNull(types.number),
    order_id: types.maybeNull(types.number),
    product_id: types.maybeNull(types.number),
    name: types.maybeNull(types.optional(types.string, "")),
    image: types.maybeNull(types.optional(types.string, "")),
    price: types.maybeNull(
      types.optional(types.union(types.string, types.number), "")
    ),
    originial_price: types.maybeNull(
      types.optional(types.union(types.string, types.number), "")
    ),
    quantity: types.maybeNull(types.number),
  })
  .views((self) => {
    return {
      get priceFmt() {
        return formatPrice(self.price.toString());
      },
      toJson() {
        // @ts-ignore
        return self.toJSON();
      },
    };
  });

const OrderModel = types
  .model({
    id: types.maybeNull(types.number),
    code: types.maybeNull(types.optional(types.string, "")),
    user_id: types.maybeNull(types.number),
    fullname: types.maybeNull(types.optional(types.string, "")),
    phone: types.maybeNull(types.optional(types.string, "")),
    email: types.maybeNull(types.optional(types.string, "")),
    province_code: types.maybeNull(types.optional(types.string, "")),
    district_code: types.maybeNull(types.optional(types.string, "")),
    ward_code: types.maybeNull(types.optional(types.string, "")),
    address: types.maybeNull(types.optional(types.string, "")),
    full_address: types.maybeNull(types.optional(types.string, "")),
    receiver_name: types.maybeNull(types.optional(types.string, "")),
    receiver_phone: types.maybeNull(types.optional(types.string, "")),
    receiver_email: types.maybeNull(types.optional(types.string, "")),
    receiver_address: types.maybeNull(types.optional(types.string, "")),
    receiver_province_code: types.maybeNull(types.optional(types.string, "")),
    receiver_district_code: types.maybeNull(types.optional(types.string, "")),
    receiver_ward_code: types.maybeNull(types.optional(types.string, "")),
    receiver_full_address: types.maybeNull(types.optional(types.string, "")),
    sub_total: types.maybeNull(
      types.optional(types.union(types.string, types.number), "")
    ),
    order_total: types.maybeNull(
      types.optional(types.union(types.string, types.number), "")
    ),
    method: types.optional(types.string, "COD"),
    source: types.maybeNull(types.optional(types.string, "")),
    status: types.maybeNull(types.optional(types.string, "")),
    carrier_status: types.maybeNull(types.optional(types.string, "")),
    financial_status: types.maybeNull(types.optional(types.string, "")),
    fulfillment_status: types.maybeNull(types.optional(types.string, "")),
    created_at: types.maybeNull(types.optional(types.string, "")),
    updated_at: types.maybeNull(types.optional(types.string, "")),
    user_created_id: types.maybeNull(types.number),
    user_created_name: types.maybeNull(types.optional(types.string, "")),
    note: types.maybeNull(types.optional(types.string, "")),
    items: types.maybeNull(types.optional(types.array(OrderItemModel), [])),
    carts: types.maybeNull(types.optional(types.array(CartModel), [])),
    payment_note: types.maybeNull(types.optional(types.string, "")),
  })
  .views((self) => {
    return {
      get paymentMethodTitle() {
        switch (self.method) {
          case "COD":
            return "Thanh toán khi giao hàng (COD)";
          case "TRANSFER":
            return "Chuyển khoản qua ngân hàng";
          case "MOMO":
            return "Thanh toán qua MOMO";
        }
      },
      get subTotalFmt() {
        if (self.id != null) {
          return formatPrice(self.order_total.toString());
        }

        let result = 0;

        self.carts.forEach((val) => {
          result += val.quantity * parseInt(val.orderPrice.toString());
        });

        return formatPrice(result.toString());
      },
      get orderTotalFmt() {
        if (self.id != null) {
          return formatPrice(self.order_total.toString());
        }

        let result = 0;
        self.carts.forEach((val) => {
          result += val.quantity * parseInt(val.orderPrice.toString());
        });

        return formatPrice(result.toString());
      },
      toJson() {
        // @ts-ignore
        return self.toJSON();
      },
    };
  })
  .actions((self) => ({
    set(key, value) {
      self[key] = value;
    },
    setMulti(object) {
      for (const [key, value] of Object.entries(object)) {
        self[key] = value;
      }
    },
    setCarts(array: any) {
      self.carts = array.map((val) => StoreHelper.createCartModel(val));
    },
  }));

export interface IOrderModel extends Instance<typeof OrderModel> {}

export default OrderModel;
